import { API_URL } from "../config/appConfig";
import RemoteService from "./RemoteService";
import _ from "lodash";
import moment from "moment";
// common api files where we can handle all apis of application

const createQueryStringFromParams = (params) => {
  let paramsList = Object.keys(params);
  if (paramsList.length) {
    return paramsList.reduce((queryString, paramKey, index) => {
      return `${queryString}${paramKey}=${params[paramKey]}${index !== paramsList.length - 1 ? "&" : ""
        }`;
    }, "?");
  } else {
    return "";
  }
};
//** <===================================== CommonList  APIs Starts here =====================================> */
export const getCertificatesList = async (params) => {
  const url = `${API_URL}/api/Certificate/GetCertificateList${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const getSourceList = async (params) => {
  const url = `${API_URL}/api/Source/GetSourceList${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const getSoftwareList = async (params) => {
  const url = `${API_URL}/api/SoftwareSystem/GetSoftwareSystemList`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const getGroupDropdownOptions = async (params) => {
  const url = `${API_URL}/api/DealerGroup/GetGroupList`;
  const response = await RemoteService.send(url, "", "GET");
  let groupList = _.get(response, "data", []);
  let updatedGroupList = groupList.map((group) => {
    return {
      ...group,
      ...{ key: group.group_Name, value: group.dealergroup_Id },
    };
  });
  return updatedGroupList;
};

export const getDealerDropDownList = async (params) => {
  const url = `${API_URL}/api/Dealer/GetDealers${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};
export const getProvinceList = async (params) => {
  const url = `${API_URL}/api/Province/GetProvinceList`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};
//** ************************************** Assign Group Page APIs Starts here ************************************** */

export const getAssignGroupDropDownList = async () => {
  const url = `${API_URL}/api/DealerGroup/GetGroupList`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const postaddAssigntoGroup = async (payload) => {
  const url = `${API_URL}/api/DealerGroup/AddAssignGroup`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

export const getGroupCheckName = async (params) => {
  const url = `${API_URL}/api/DealerGroup/CheckGroups${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const getDealersListByGroup = async (params) => {
  const url = `${API_URL}/api/DealerGroup/GetallDealers${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

//** ************************************** Dashboard Group Page APIs Starts here ************************************** */
export const getDashboardDealercount = async (params) => {
  const url = `${API_URL}/api/Dealer/GetDealerDashboardDetail${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const getDashboardVehiclecount = async (params) => {
  const url = `${API_URL}/api/Vehicle/GetVehicleDashboardDetail${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const postTurnoverGraph = async (params) => {
  const url = `${API_URL}/api/InvoicingReport/GetDashboardTurnOverData${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "POST");
  return response.data;
};

export const postTradeMarkGraph = async (params) => {
  const url = `${API_URL}/api/InvoicingReport/GetDashboardTurnOverTrademarkData${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "POST");
  return response.data;
};

export const getStatusApiList = async (params) => {
  const url = `${API_URL}/api/DashboardApiStatus/DashboardAPIStatus`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

//** ************************************** CommonList APIs Starts here ************************************** */

//** <===================================== Dealer Related APIs Starts here =====================================> */
export const getDealerList = async (params) => {
  const url = `${API_URL}/api/Dealer/GetDealersList${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET", "");
  return response.data;
};

export const getDealerDetails = async (params) => {
  const url = `${API_URL}/api/Dealer/GetDealerById${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const updateDealerStatus = async (payload) => {
  const url = `${API_URL}/api/Dealer/UpdateDealerStatus`;

  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

export const deleteDealer = async (params) => {
  const url = `${API_URL}/api/Dealer/DeleteDealer${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

// Soft Remove dealer from Dealer Group
export const removeDealer = async (params) => {
  const url = `${API_URL}/api/Dealer/RemoveDealer${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const deleteGroup = async (params) => {
  const url = `${API_URL}/api/DealerGroup/DeleteDealerGroup${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};



export const postDealerDetails = async (values) => {
  const isAutomatic = localStorage.getItem('isExactAutomatic') === 'true';
  let certificateList = _.get(values, "Assign_Certificates", []).map(
    (certificate) => {
      let certificateName =
        certificate.value?.charAt(0)?.toLowerCase() +
        certificate?.value?.slice(1);
      return {
        [certificateName]: true,
      };
    }
  );

  let certificateObj = certificateList.reduce(
    (prev, curr) => ({ ...prev, ...curr }),
    {}
  );
  

  const payload = {
    ...values,
    ...certificateObj,
    ...{
      dealer_Status: _.get(values, "dealer_Status.value", null),
      source_System_Id:
        _.get(values, "keyValuePairSource.value", null) !== 0
          ? _.get(values, "source_System_Id.value", null)
          : 10,
      combine_Certificate: _.get(values, "combine_Certificate.value", null),
      certificate_Email_Id: _.isEmpty(_.get(values, "certificate_Email_Id", ""))
        ? _.get(values, "email_Id", "")
        : _.get(values, "certificate_Email_Id", ""),
      Software_System_Id:
        _.get(values, "keyValuePairSoftwareSystem.value", null) !== 0
          ? _.get(values, "software_System.value", null)
          : 1,
      exact_Number: isAutomatic ? _.get(values, "exact_Number.value", "" ) : _.get(values, "exact_number_manual", "" )
    },
  };
  delete payload["Assign_Certificates"];
  delete payload["province"];
  delete payload["keyValuePairSource"];

  delete payload["keyValuePairStatus"];
  delete payload["software_System"];

  delete payload["keyValuePairProvince"];
  delete payload["exact_number_manual"];

  const url = `${API_URL}/api/Dealer/AddDealer`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};
//** <************************************** Dealer Related APIs Ends here **************************************> */

//** <===================================== Vehicle Related APIs Starts here =====================================> */

export const getVehicleList = async (params) => {
  const url = `${API_URL}/api/Vehicle/GetVehicleList${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const getVehicleDetails = async (params) => {
  const url = `${API_URL}/api/Vehicle/getVehicleById${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const postVehicleDetails = async (values) => {
  let Is_certificatesMandatory = _.get(values, "certificates", []).length > 0;

  let certificateList = Is_certificatesMandatory ? _.get(values, "certificates", []).map((certificate) => {
    let certificateName =
      _.get(certificate, "certificate_Name.value", "")
        ?.charAt(0)
        ?.toLowerCase() +
      _.get(certificate, "certificate_Name.value", "")?.slice(1);
    return {
      [certificateName]: true,
      [`${certificateName}_Date`]: moment
        .utc(_.get(certificate, "updatedDate", new Date()), "DD-MM-YYYY")
        .toISOString(),
    };
  }) : [];
  let certificateObj = certificateList.reduce(
    (prev, curr) => ({ ...prev, ...curr }),
    {}
  );

  values["date_of_Admission"] = moment
    .utc(values["date_of_Admission"], "DD-MM-YYYY")
    .toISOString();

  values["ad_Status_Date"] = moment.utc(values["ad_Status_Date"]).toISOString();

  values["kilometer_Stand"] = +_.get(values, "kilometer_Stand", 0);
  const payload = {
    ...values,
    ...certificateObj,
    ...{
      dealer_Name: _.get(values, "dealerName.key", ""),
      dealer_Id: _.get(values, "dealerName.value", ""),
      ad_Status: _.get(values, "ad_Status.value", null),
      is_certificatesMandatory: Is_certificatesMandatory,
    },
  };

  delete payload["dealerName"];
  delete payload["certificates"];
  delete payload["keyValuePairStatus"];

  const url = `${API_URL}/api/Vehicle/addVehicle`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

export const deleteVehicleCertificate = async (payload) => {
  const url = `${API_URL}/api/Vehicle/DeleteVehicleCertificates`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

export const updateVehicleCertificate = async (payload) => {
  const url = `${API_URL}/api/Vehicle/UpdateVehicleCertificate`;

  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};
export const filterVehicleList = async (payload) => {
  const url = `${API_URL}/api/Vehicle/getFilteredVehicle`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};


//** <************************************** Vehicle Related APIs Starts here **************************************> */
//** <===================================== Export  APIs Starts here =====================================> */
export const exportVehilce = async (values) => {
  values["toDate"] = moment(values.toDate, "DD-MM-YYYY").format("YYYY-MM-DD");
  values["fromeDate"] = moment(values.fromeDate, "DD-MM-YYYY").format(
    "YYYY-MM-DD"
  );

  const payload = values;
  delete payload["dealerList"];
  delete payload["AssignCertificatesOptions"];
  delete payload["stauts"];

  const url = `${API_URL}/api/Vehicle/ExportVehicle`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};
export const exportVehicleFromDealerDetails = async (dealerId) => {
  const payload = {
    fromeDate: "1970-01-01",
    toDate: moment(new Date(), "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    ),
    certificateIds: [
      1,
      2,
      3,
      4,
      5
    ],
    vehicle_Status: 100,
    dealerIds: [
      dealerId
    ]
  }

  const url = `${API_URL}/api/Vehicle/ExportVehicle`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

export const exportDealer = async (values) => {
  values["toDate"] = moment(values.toDate, "DD-MM-YYYY").format("YYYY-MM-DD");
  values["fromeDate"] = moment(values.fromeDate, "DD-MM-YYYY").format(
    "YYYY-MM-DD"
  );

  const payload = values;
  delete payload["dealerList"];
  delete payload["providerList"];
  delete payload["dealerStatus"];
  delete payload["provinceList"];
  delete payload["groupList"];

  const url = `${API_URL}/api/Dealer/ExportDealer`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};
//** <************************************** Export  API Ends here **************************************> */
/**  <************************************** Group page  API starts here **************************************> */
export const getGroupPageListAPI = async (params) => {
  const url = `${API_URL}/api/DealerGroup/GetListforGroupPage${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const getGroupDetailsAPI = async (params) => {
  const url = `${API_URL}/api/DealerGroup/GetListforGroupPage${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const postGroupDetails = async (payload) => {
  const url = `${API_URL}/api/DealerGroup/AddAssignGroup`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};
/**  <************************************** Group page  API ends here **************************************> */

//** <************************************** Log  API start here **************************************> */
export const getDealerLogs = async (params) => {
  const url = `${API_URL}/api/DealerLog/GetDealerLogDetail${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};
export const getDealerLogsCSV = async (params) => {
  const url = `${API_URL}/api/DealerLog/ExportDealerLogDetail${createQueryStringFromParams(
    params
  )}`;

  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const getVehicleLogs = async (params) => {
  const url = `${API_URL}/api/VehicleLog/GetVehicleLogDetail${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};
export const getVehicleLogsCSV = async (params) => {
  const url = `${API_URL}/api/VehicleLog/ExportVehicleLogDetail${createQueryStringFromParams(
    params
  )}`;

  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};
//** <************************************** Log  API ends here **************************************> */

//** <************************************** Report  API start here **************************************> */
export const postReportAPI = async (payload) => {
  payload["toDate"] = moment(payload.toDate, "DD-MM-YYYY").format("YYYY-MM-DD");
  payload["fromeDate"] = moment(payload.fromeDate, "DD-MM-YYYY").format(
    "YYYY-MM-DD"
  );
  const url = `${API_URL}/api/InvoicingReport/ViewInvoicingReport`;

  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

export const generateInvoice = async (payload) => {
  payload["toDate"] = moment(payload.toDate, "DD-MM-YYYY").format("YYYY-MM-DD");
  payload["fromeDate"] = moment(payload.fromeDate, "DD-MM-YYYY").format(
    "YYYY-MM-DD"
  );

  const url = `${API_URL}/api/InvoicingReport/GenerateInvoicingReport`;

  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

//** <************************************** Report  API end here **************************************> */

//** <************************************** Exact  API start here **************************************> */

export const postExactAuthCode = async (payload) => {
  const url = `${API_URL}/api/Exact/GetExactAuthToken${createQueryStringFromParams(
    payload
  )}`;

  const response = await RemoteService.send(url, "", "POST", "");
  return response.data;
};

export const exactSyncApiStatus = async (params) => {
  const url = `${API_URL}/api/Exact/GetExactSyncStatus${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const syncExactTableApi = async (type, fullRefresh) => {
  const syncTerm = fullRefresh ? 0 : 1;
  let url;
  if (type === 1) {
    url = `${API_URL}/api/Exact/GetExactAccountDetails?SyncTerm=${syncTerm}`;
  } else if (type === 2) {
    url = `${API_URL}/api/Exact/GetExactSubscriptions?SyncTerm=${syncTerm}`;
  } else if (type === 3) {
    url = `${API_URL}/api/Exact/GetExactSubscriptionLines?SyncTerm=${syncTerm}`;
  } else if (type === 4) {
    url = `${API_URL}/api/Exact/GetExactItems?SyncTerm=${syncTerm}`;
  }

  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const getExactSyncButtonDetails = async () => {
  const url = `${API_URL}/api/Exact/GetExactSyncButtonSettingDetails`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};
export const ExactSyncButtonDetails = async (payload) => {
  const url = `${API_URL}/api/Exact/GetExactSyncButtonSetting`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};
export const getExactDetails = async (params) => {
  const url = `${API_URL}/api/Dealer/Getexactdealerdetails${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const getExactDealerList = async (params) => {
  const url = `${API_URL}/api/Dealer/GetExactDealersList${createQueryStringFromParams(
    params
  )}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

//** <************************************** Exact  API end here **************************************> */
//** <************************************** Email  API start here **************************************> */

export const sendCertificateMail = async (params) => {
  const url = `${API_URL}/api/CertificateEmail/SendEmailService${createQueryStringFromParams(
    params
  )}`;

  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const saveCertifciateMail = async (payload) => {
  const url = `${API_URL}/api/CertificateEmail/AddEmailTemplate`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

export const previewCertificateChange = async (payload) => {
  const url = `${API_URL}/api/CertificateEmail/PreviewEmailTemplate`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

export const getTemplateSectionbyId = async (params) => {
  const url = `${API_URL}/api/CertificateEmail/GetTemplateByCertificateId${createQueryStringFromParams(
    params
  )}`;

  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const sendDealerBulkEmail = async (payload) => {
  const url = `${API_URL}/api/CertificateEmail/SendBulkEmailToDealers`;

  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

export const previewDealerBulkEmail = async (payload) => {
  const url = `${API_URL}/api/CertificateEmail/BulkPreviewEmailTemplate`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

//** <************************************** Email  API end here **************************************> */

//** <************************************** Certificate Templates  API start here **************************************> */
export const previewCertificateTemplate = async (payload) => {
  const url = `${API_URL}/api/CertificateEmail/DummyCertificateSetting`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

export const previewVehicleCertificateTemplate = async (payload) => {
  const url = `${API_URL}/api/CertificateEmail/ViewManageCertificate`;
  const response = await RemoteService.send(url, "", "POST", payload, "blob");
  return response.data;
};

export const deleteVehicleCertificateTemplate = async (payload) => {
  const url = `${API_URL}/api/CertificateEmail/DeleteCertificateTemplate`;
  const response = await RemoteService.send(url, "", "POST", payload);
  return response.data;
};

//** <************************************** Certificate Templates  API end here **************************************> */

export const UpdateExactAppSetting = async (value) => {
  const url = `${API_URL}/api/Exact/UpdateExactAppSetting?SettingType=${value}`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};

export const GetExactSetting = async (value) => {
  const url = `${API_URL}/api/Exact/GetExactSetting`;
  const response = await RemoteService.send(url, "", "GET");
  return response.data;
};